import EventVisualisationSkeletonImpl from './event-visualisation-skeleton.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Visualisation skeleton component used to represent loading scoreboard, stream and tabs.
 *
 * @function EventVisualisationSkeleton
 * @memberof Mojito.Modules
 */

export default UIView('EventVisualisationSkeleton', EventVisualisationSkeletonImpl);
